import axios from 'axios';
export class IdentityServerDAO {
    static get idpBaseUrl() {
        return process.env.VUE_APP_IDP_BASE_URL;
    }
    static get idpSpClientId() {
        return process.env.VUE_APP_IDM_SP_CLIENT_ID;
    }
    static get idpSpClientSecret() {
        return process.env.VUE_APP_IDM_SP_CLIENT_SECRET;
    }
    static async getServiceProviderAccessToken() {
        let token = '';
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Access-Control-Allow-Origin': '*',
                'Accept': 'application/json'
            }
        };
        let postBody = 'client_id=' + this.idpSpClientId + '&client_secret=' + this.idpSpClientSecret + '&grant_type=client_credentials';
        try {
            let tokenResponse = await axios.post(this.idpBaseUrl + '/oauth2/token', postBody, axiosConfig);
            token = tokenResponse.data.access_token;
        }
        catch (error) {
            console.log('Token error: ' + error);
            token = '';
        }
        return token;
    }
    static async getUserAccessToken(emailAddress, password) {
        let token = '';
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Access-Control-Allow-Origin': '*',
                'Accept': 'application/json',
                'Authorization': 'Basic eEFFZ1ladzhCX1hhcFhtcURUcEVOV3hfT3UwYToxZTNfb3VWZjdxdktFMGVpOWRIZUVxSnJrOFlh'
            }
        };
        let postBody = 'username=' + emailAddress + '&password=' + password + '&grant_type=password&scope=openid';
        try {
            let tokenResponse = await axios.post(this.idpBaseUrl + '/oauth2/token', postBody, axiosConfig);
            token = tokenResponse.data.access_token;
        }
        catch (error) {
            console.log('Token error: ' + error);
            token = '';
        }
        return token;
    }
}
